export { default as UserSubtractOutlineIcon } from './UserSubtractOutlineIcon';
